import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction, WritableDraft } from '@reduxjs/toolkit';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppCore from '@/utilities/AppCore';

export interface ModalsState {
  isAgePassed: boolean,
};

const initialState: ModalsState = {
  isAgePassed: AppCore.getDefaultIsAgePassed(),
} satisfies ModalsState as ModalsState;

export const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    setAgePassed: (state, newState: PayloadAction<boolean>) => {
      state.isAgePassed = newState.payload;
      AppUtilities.setStoredValue("isAgePassed", { val: true });
    },
  },
});

export const {
  setAgePassed,
} = modalsSlice.actions;

export default modalsSlice.reducer;
